import { FieldMap, FieldMapValue } from '../types'
import { defaultStageValidate } from '../utils/fields'
import { getIntroductionFormStages } from './introduction'

export const getSummaryFields = (data: FieldMapValue): FieldMap => ({
  name: 'Questionnaire Summary',
  children: getIntroductionFormStages(false, data),
})

const getNoPlanToAssess = (data: FieldMapValue) => {
  const notPregnant = data?.insuranceInfo?.option === 'not-pregnant'
  if (!notPregnant) return false
  const notPregnantOption = data?.insuranceInfo?.notPregnantOption
  if (!notPregnantOption) return false
  if (notPregnantOption === 'current-plan') return false
  return true
}

export const getQuestionnaireSummaryComplete = (data: FieldMapValue) => {
  const summaryFields = getSummaryFields(data)
  const errors = defaultStageValidate(summaryFields, true)(data)
  if (errors) return false
  const noPlanToAssess = getNoPlanToAssess(data)
  return !noPlanToAssess
}
